import { IUser, ILoginRequestDTO, IRequestNewPasswordDTO, IChangePasswordDTO, IResetPassword } from "../models";
import { IGuild } from "../models/IGuild";
import { AuthenticatedFetch, CreateAuthHeader } from "../utils/Helpers";

export interface IMasterDataService
{
    Login(model: ILoginRequestDTO) : Promise<IUser | undefined>;
    SignOut(): void;
    RequestNewPassword(model: IRequestNewPasswordDTO) : Promise<boolean>;
    ResetPassword(model: IResetPassword): Promise<boolean>;
    /** Returnerer en fejlbesked, eller undefined hvis adgangskoden blev ændret */
    ChangePassword(model: IChangePasswordDTO): Promise<string | undefined>;
    SetGuild(guild: IGuild |undefined) : Promise<boolean>;
}

export class TooManyLoginAttemptsError extends Error
{
    constructor()
    {
        super("For mange loginforsøg");
        this.name = "TooManyLoginAttemptsError";
    }
}

export class MasterDataService implements IMasterDataService
{    
    //private controller = "api/application";
    public async Login(model: ILoginRequestDTO) : Promise<IUser | undefined>
    {
        if(!model.email || !model.password)
        {
            return undefined;
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        };

        const response = await fetch('api/authenticate', requestOptions);
        if(response.ok)
        {
            return await response.json() as IUser;
        }

        if(response.status === 429)
        {
            throw new TooManyLoginAttemptsError();
        }

        return undefined;
    }

    public SignOut()
    {
        sessionStorage.removeItem('uhrevind_token');
        window.location.href = "/";
    }

    public async RequestNewPassword(model: IRequestNewPasswordDTO) : Promise<boolean>
    {
        if(!model.email)
        {
            return false;
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        };

        const response = await fetch('api/requestpassword', requestOptions);
        if(!response.ok)
        {
            return false;
        }

        return true;
    }

    public async ResetPassword(model: IResetPassword): Promise<boolean>
    {
        if(!model.prFlowId || !model.password)
        {
            return false;
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(model)
        };

        const response = await fetch('api/resetpassword', requestOptions);
        if(!response.ok)
        {
            return false;
        }

        return true;
    }

    public async ChangePassword(model: IChangePasswordDTO): Promise<string | undefined>
    {
        if(!model.existingPassword || !model.newPassword || !model.confirmNewPassword)
        {
            return "Udfyld alle felter.";
        }

        const requestOptions = {
            method: 'POST',
            headers: CreateAuthHeader(),
            body: JSON.stringify(model)
        };

        const response = await AuthenticatedFetch('api/application/change-password', requestOptions);
        if(!response.ok)
        {
            // Backend returnerer en dansk fejlbesked som tekst - ved valideringsfejl (JSON) vises en generel besked
            const contentType = response.headers.get("content-type") || "";
            const message = contentType.startsWith("text/plain") ? await response.text() : "";
            return message || "Din adgangskode kunne ikke ændres.";
        }

        return undefined;
    }

    public async SetGuild(guild: IGuild | undefined) : Promise<boolean>
    {
        const requestOptions = {
            method: 'POST',
            headers: CreateAuthHeader(),
            body: JSON.stringify({GuildID: guild?.id} as any)
        };

        const response = await AuthenticatedFetch('api/application', requestOptions);
        if(response.ok)
        {
            return true;           
        } else
        {
            return false;
        }
    }

    /*public async GetUsers() : Promise<ICreateOrUpdateUserDTO[]>
    {
        const requestOptions = {
            method: 'GET',
            headers: CreateAuthHeader()
        };

        const response = await fetch('users', requestOptions);
        if(!response.ok)
        {
        }

        let users = await response.json() as ICreateOrUpdateUserDTO[];

        for(let u of users)
        {
            u.regionName = u.region?.name;
            u.supplierName = u.supplier?.name;
        }

        return users;
    }*/

    
}